import { combineReducers } from "redux";

import modelPriceAdmin from "./modelPrice/modelPrice.reducer";

const rootReducer = combineReducers({
  modelPriceAdmin,
});

export default rootReducer;
